<template>
  <div>
    <LoadingState
      v-if="loading"
      :loading="loading"
    />
    <v-container
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
      >
        <stores-list />
        <settings-options-grid />
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'
import StoresList from '@/modules/Settings/components/StoresList'
import SettingsOptionsGrid from '@/modules/Settings/components/SettingsOptionsGrid'

export default {
  name: 'Settings',

  components: {
    LoadingState,
    StoresList,
    SettingsOptionsGrid
  },

  data () {
    return {
      loading: false
    }
  }
}
</script>
